export const PERIOD = {
  days: {
    min: 5,
    max: 365,
  },
  months: {
    min: 12,
    max: 30,
  },
};

export const AMOUNT = {
  min: 3000,
  max: 300000,
};
